module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity/product-images/frat-product-8-368cfa442acffd74f44d752faab51a95.jpg";